<template>
    <div class="mt-5">
        <LabeledCard :label="isNew ? $t('Добавление нового предписания') : $t('Редактирование предписания')">
            <v-container class="pt-5 px-5" fluid>
                <v-form ref="prescriptionForm">
                    <v-row v-show="!isNew">
                        <v-text-field
                            :label="$t('Дата формирования')"
                            class="d-inline-block mr-15 date-picker"
                            v-model="formed_date"
                            :clearable="false"
                            readonly
                        />
                        <v-text-field :label="$t('Дата выдачи')" class="d-inline-block mr-15 date-picker" v-model="issue_date" :clearable="false" readonly />
                    </v-row>
                    <v-row class="mt-2" v-if="!ksk_house_rid">
                        <v-select
                            dense
                            outlined
                            :label="$t('Договор')"
                            :items="CLT"
                            item-text="contract_number"
                            item-value="contract_rid"
                            v-model="contract_rid"
                            :readonly="readonly || disableEdit"
                            :hide-details="readonly"
                        ></v-select>
                    </v-row>
                    <v-row class="mt-2" v-if="!ksk_house_rid">
                        <v-select
                            dense
                            outlined
                            :label="$t('Наименование объекта')"
                            :items="OLT"
                            item-text="object_name"
                            item-value="obj_contract_rid"
                            v-model="obj_contract_rid"
                            :hide-details="readonly"
                            :readonly="readonly || disableEdit"
                            :rules="requiredWhenDateEnd"
                            :clearable="!readonly && !disableEdit"
                        ></v-select>
                    </v-row>
                    <v-row class="mt-2" v-if="!obj_contract_rid">
                        <v-select
                            dense
                            outlined
                            :label="$t('Адреса дома')"
                            :items="KHLT"
                            item-text="address_full_name"
                            item-value="ksk_house_rid"
                            v-model="ksk_house_rid"
                            :readonly="readonly || disableEdit"
                            :hide-details="readonly"
                            :rules="requiredWhenDateEnd"
                            :clearable="!readonly && !disableEdit"
                        ></v-select>
                    </v-row>
                    <v-row class="mt-2">
                        <v-textarea maxlength="500" outlined auto-grow v-model="comment" :readonly="readonly || disableEdit" :label="$t('Комментарий')">
                        </v-textarea>
                    </v-row>
                    <v-row>
                        <v-expansion-panels>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    {{ $t('Список мероприятий') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <EventEdit v-for="item in events" :key="item.event_type_rid" :event="item" />
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>
                    <v-row class="mt-2 d-flex align-center flex-column">
                        <div class="mb-3">
                            <v-btn v-if="document.ahs_document_rid" color="primary" @click="downloadFile" :title="$t('Скачать файл')">
                                <v-icon left>mdi-download-outline</v-icon>
                                <span>{{ document.doc_type_name ? document.doc_type_name : PIT.req_documents[0].doc_type_name }}</span></v-btn
                            >
                        </div>
                        <div v-if="!readonly">
                            <span v-if="document.ahs_document_rid" class="label">{{ $t('Документ выбран') }}</span>
                            <span v-else style="color: red">{{ $t('Требуется добавить документ') }}</span>
                        </div>
                        <v-row v-if="!readonly">
                            <AddEditDocument
                                :isNew="true"
                                :document="document"
                                :contract_rid="contract_rid"
                                :obj_contract_rid="obj_contract_rid"
                                :ksk_house_rid="ksk_house_rid"
                            />
                        </v-row>
                    </v-row> </v-form
                ><v-row class="mt-2">
                    <v-col cols="12" class="d-flex justify-end">
                        <v-btn outlined color="primary" @click="$router.push('/prescription')">{{ $t('Закрыть') }}</v-btn>
                        <v-btn v-if="!readonly" class="ml-5" color="primary" @click="clickSave" :loading="loading">{{ $t('Сохранить') }}</v-btn>
                    </v-col>
                </v-row></v-container
            ></LabeledCard
        >
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LabeledCard from '@/components/ui/LabeledCard.vue';
import translate from '@/utils/translate.util';
import BinCheckMixin from '@/mixins/BIN_Checker';
import FormValidator from '@/mixins/FormValidator';
import fileSaver from 'file-saver';
import EventEdit from '@/components/ui/EventEdit.vue';
import AddEditDocument from '@/components/ui/AddDocumentPresc.vue';
export default {
    name: 'AddEditPrescription',
    mixins: [BinCheckMixin, FormValidator],
    components: { LabeledCard, EventEdit, AddEditDocument },
    data: () => ({
        isNew: false,
        isContract: false,
        presc: null,
        dialog: false,
        comment: null,
        readonly: true,
        contract_rid: null,
        obj_contract_rid: null,
        ksk_house_rid: null,
        loading: false,
        formed_date: null,
        issue_date: null,
        events: [],
        record_id: null,
        document: { ahs_document_rid: null, doc_type_name: null },
        disableEdit: false
    }),
    computed: {
        ...mapState('prescription', [
            'EventTypeList',
            'PrescriptionPagination',
            'PrescriptionInfo',
            'iengineer_rid',
            'EngineerKSKHousesList',
            'EngineerContractsList',
            'EngineerObjectContractsList'
        ]),
        ...mapState('documents', ['DocTypeList', 'ContractList', 'ObjectList', 'KSKHouseList', 'Pagination', 'ContractRid', 'KSKRid', 'file']),
        ...mapState('users', ['userInfo']),
        ...mapState('permissions', ['userPermissions']),
        CLT() {
            return translate(this.EngineerContractsList, 'full', this.$i18n.locale);
        },
        OLT() {
            //console.log('this.EngineerObjectContractsList', this.EngineerObjectContractsList);
            return translate(this.EngineerObjectContractsList, 'full', this.$i18n.locale);
        },
        KHLT() {
            return translate(this.EngineerKSKHousesList, 'full', this.$i18n.locale);
        },
        ETLT() {
            return translate(this.EventTypeList, 'full', this.$i18n.locale);
        },
        requiredWhenDateEnd: function(v) {
            let req = !this.obj_contract_rid && !this.ksk_house_rid;
            let reqr = this.obj_contract_rid && this.ksk_house_rid;
            if (reqr) {
                return [v => !reqr || this.$t('Необходимо выбрать адрес дома или обьект')];
            }
            return [v => !req || this.$t('Обязательное поле')];
        },
        PIT() {
            return translate(this.PrescriptionInfo, 'full', this.$i18n.locale);
        }
    },
    methods: {
        ...mapActions('prescription', [
            'postPrescriptions',
            'getPrescriptions',
            'getPrescriptionInfo',
            'getEventTypes',
            'getEngineerKSKHousesList',
            'getEngineerObjectContractsList',
            'getEngineerContractsList',
            'prescriptionStatusTypes'
        ]),
        ...mapActions('documents', ['getUserObjectContractsList', 'postDoc', 'attachmentsTempInsert', 'getDocumentList', 'getFile']),
        ...mapActions('users', ['getUserInfo']),
        async openDialog() {
            await this.getEventTypes();
            (this.record_id = null), (this.comment = null);
            this.contract_rid = null;
            this.obj_contract_rid = null;
            this.ksk_house_rid = null;
            this.dialog = true;
            this.readonly = !this.userPermissions.some(x => x === 'prescription_update');
            this.events = [];
            this.formed_date = null;
            this.issue_date = null;
            this.ETLT.forEach(element => {
                this.events.push({
                    event_type_rid: element.event_type_rid,
                    event_type_name: element.event_type_name,
                    event_start: null,
                    event_end: null
                });
            });
            this.document = { ahs_document_rid: null, doc_type_name: null };
            this.disableEdit = false;
        },
        async downloadFile() {
            await this.getFile({
                iAhsDocument_rid: this.document.ahs_document_rid
            }).then(() => {
                const byteOffset = 0;
                const b = new Blob([new Uint8Array(this.file.attach_file.data, byteOffset, length)]);
                const reader = new FileReader();

                reader.readAsDataURL(b);
                //console.log(this.file);
                reader.onload = () => {
                    fileSaver.saveAs(reader.result, this.file.attach_file_name);
                };
            });
        },
        async openEdit() {
            await this.getPrescriptionInfo({ iPrescription_rid: this.presc });
            await this.getEventTypes();

            this.document = { ahs_document_rid: null, doc_type_name: null };
            this.record_id = this.PrescriptionInfo.record_id;
            this.document.ahs_document_rid =
                this.PrescriptionInfo.req_documents && this.PrescriptionInfo.req_documents.length > 0 ? this.PrescriptionInfo.req_documents[0].record_id : null;
            this.comment = this.PrescriptionInfo.note;
            this.contract_rid =
                this.PrescriptionInfo.object_contracts && this.PrescriptionInfo.object_contracts.length > 0
                    ? this.PrescriptionInfo.object_contracts[0].contract_rid
                    : null;
            this.obj_contract_rid =
                this.PrescriptionInfo.object_contracts && this.PrescriptionInfo.object_contracts.length > 0
                    ? this.PrescriptionInfo.object_contracts[0].object_contract_rid
                    : null;
            this.ksk_house_rid =
                this.PrescriptionInfo.ksk_houses && this.PrescriptionInfo.ksk_houses.length > 0 ? this.PrescriptionInfo.ksk_houses[0].ksk_house_rid : null;
            this.dialog = true;
            this.readonly =
                this.PrescriptionInfo.status_code_name == 'completed' ||
                this.PrescriptionInfo.status_code_name == 'canceled' ||
                !this.userPermissions.some(x => x === 'prescription_update');
            this.disableEdit = this.PrescriptionInfo.status_code_name == 'issued';
            this.events = [];
            this.formed_date = this.PrescriptionInfo.formed_date;
            this.issue_date = this.PrescriptionInfo.issue_date;

            const exists = this.PrescriptionInfo.prescription_events && this.PrescriptionInfo.prescription_events.length > 0;
            this.ETLT.forEach(element => {
                const savedEvent = exists ? this.PrescriptionInfo.prescription_events.find(t => t.event_type_rid == element.event_type_rid) : null;
                this.events.push({
                    event_type_rid: element.event_type_rid,
                    event_type_name: element.event_type_name,
                    event_start: savedEvent ? savedEvent.dead_line_plan : null,
                    event_end: savedEvent ? savedEvent.dead_line_fact : null
                });
            });

            if (!this.iengineer_rid) {
                this.$store.commit('prescription/setiengineer_rid', this.PrescriptionInfo.engineer_rid);
                await this.getEngineerContractsList({ iengineer_rid: this.iengineer_rid });
                await this.getEngineerKSKHousesList({ iengineer_rid: this.iengineer_rid });
                await this.getEngineerObjectContractsList({ icontract_rid: this.contract_rid, iengineer_rid: this.iengineer_rid });
            }
        },
        async clickSave() {
            this.loading = true;
            try {
                if (!this.$refs.prescriptionForm.validate() || !this.document.ahs_document_rid) return;

                let data = {};
                data.record_id = this.record_id;
                data.to_delete = 0;
                data.attachment_link_rid = this.attachment_link_rid;
                data.note = this.comment;
                data.user_rid = this.userInfo.record_id;
                if (this.obj_contract_rid) data.object_contracts = [{ object_contract_rid: this.obj_contract_rid, to_delete: 0 }];
                if (this.ksk_house_rid) data.ksk_houses = [{ ksk_house_rid: this.ksk_house_rid, to_delete: 0 }];
                data.formed_date = this.formed_date;
                data.issue_date = this.issue_date;
                data.ahs_documents = [{ ahs_document_rid: this.document.ahs_document_rid, to_delete: 0 }];
                data.ahs_events = [];
                this.events.forEach(element => {
                    if (!element.event_start && !element.event_end) {
                        data.ahs_events.push({
                            event_type_rid: element.event_type_rid,
                            to_delete: 1
                        });
                    } else {
                        data.ahs_events.push({
                            event_type_rid: element.event_type_rid,
                            dead_line_plan: element.event_start,
                            dead_line_fact: element.event_end,
                            to_delete: 0
                        });
                    }
                });

                const res = await this.postPrescriptions({ nvcPrescriptionData: data });
                if (res && res.successfull) {
                    let color = 'success';
                    let message = this.$t('Предписание успешно добавлено');
                    this.$store.dispatch('base/showMessage', { color, message });
                }
                await this.getPrescriptions({
                    itemsPerPage: this.PrescriptionPagination.itemsPerPage,
                    currentItem: this.PrescriptionPagination.itemsPerPage * (this.PrescriptionPagination.page - 1)
                });
                this.$router.push('/prescription');
            } finally {
                this.loading = false;
            }
        }
    },
    watch: {
        async contract_rid() {
            if (this.iengineer_rid) this.getEngineerObjectContractsList({ icontract_rid: this.contract_rid, iengineer_rid: this.iengineer_rid });
        },
        obj_contract_rid() {
            if (this.obj_contract_rid == null) this.contract_rid = null;
        }
    },
    async created() {
        if (!this.iengineer_rid) {
            await this.getUserInfo();
            if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_engineer_rid) {
                this.engineer_rid = this.userInfo.user_data.isas_engineer_rid;
            }
            this.user_id = this.userInfo.record_id;

            //this.engineer_rid = 2;
            this.$store.commit('prescription/setiengineer_rid', this.engineer_rid);
        }

        const id = this.$route.params.id;
        if (id) {
            this.isNew = false;
            this.presc = id;
            this.openEdit();
        } else {
            this.isNew = true;
            this.openDialog();
        }
        if (this.iengineer_rid) {
            await this.getEngineerKSKHousesList({ iengineer_rid: this.iengineer_rid });
            await this.getEngineerContractsList({ iengineer_rid: this.iengineer_rid });
        }
    }
};
</script>
